@let owner = ownerSummary();

<div class="rounded-3xl border border-neutral-3 bg-neutral-1 shadow-sm p-5 sm:p-6 flex flex-col gap-5">
  <div class="flex items-center gap-3.5">
    <div
      class="flex size-12 shrink-0 items-center justify-center rounded-2xl bg-jade-2 text-jade-11 font-extrabold text-lg border border-jade-4/70"
    >
      {{ owner.firstName ? owner.firstName.charAt(0) : 'P' }}
    </div>
    <div>
      <div class="text-base font-bold text-neutral-12 leading-tight">
        {{ owner.firstName }}
      </div>
      <div class="flex items-center gap-1.5 text-xs text-neutral-10 mt-0.5">
        <span>Propriétaire vendeur</span>
        @if (owner.isVerified) {
          <span class="inline-flex items-center gap-0.5 text-jade-11 font-semibold">
            <mat-icon class="!text-xs size-3.5">verified</mat-icon>
            Vérifié
          </span>
        }
      </div>
    </div>
  </div>

  <div class="flex flex-col gap-2 pt-3 border-t border-neutral-3 text-xs text-neutral-11">
    @if (owner.responseTime; as time) {
      <div class="flex items-center justify-between">
        <span class="text-neutral-10">Délai moyen de réponse</span>
        <span class="font-semibold text-neutral-12">{{ time }}</span>
      </div>
    }
    @if (owner.memberSince; as since) {
      <div class="flex items-center justify-between">
        <span class="text-neutral-10">Membre depuis</span>
        <span class="font-semibold text-neutral-12">
          {{ since | luxonDate: 'MMMM yyyy' }}
        </span>
      </div>
    }
  </div>

  <button
    mat-stroked-button
    class="w-full !py-3.5 font-bold text-xs !border-neutral-4 hover:!bg-neutral-2 shadow-xs transition-colors primary"
    (click)="contactOwner.emit()"
  >
    Envoyer un message au propriétaire
  </button>
</div>
